import { useSeo } from "@/lib/seo";

const CONTENT = {
  terms: {
    title: "Terms of Service",
    intro: "Welcome to AlumniPulse.net. By using our platform you agree to these terms.",
    sections: [
      ["Using AlumniPulse", "You may use AlumniPulse to build your educational profile, connect with alumni, manage institution websites, and participate in communities. You agree to provide accurate information and to respect other members."],
      ["Your content", "You retain ownership of the content you post. By posting, you grant AlumniPulse a licence to display and distribute it on the platform. You are responsible for the content you publish, including institution pages you manage."],
      ["Acceptable use", "Do not post unlawful, harmful, or misleading content, impersonate others, scrape data without permission, or misuse the reconnection tools. We may remove content or suspend accounts that violate these terms."],
      ["Institution websites", "Managers who claim an institution are responsible for the accuracy of the information published on that institution's website and for having the authority to represent it."],
      ["Changes", "We may update these terms from time to time. Continued use of the platform means you accept the updated terms."],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    intro: "Your privacy matters. This policy explains what we collect and how we use it.",
    sections: [
      ["What we collect", "Account details (name, email), profile and education history you choose to add, content you post, and basic usage data to keep the service running and secure."],
      ["How we use it", "To operate the platform, power alumni search and reconnection, personalise your experience, and communicate with you. We do not sell your personal data."],
      ["Your controls", "You control per-field visibility on your profile (public, alumni-only, or private). You can edit or delete your information at any time."],
      ["Sharing", "We share data only as needed to run the service, comply with the law, or with your consent. AlumniPulse is operated by Social Pulse Inc."],
      ["Contact", "For privacy or data requests, email privacy@alumnipulse.net. To report abuse or inappropriate content, email abuse@alumnipulse.net."],
    ],
  },
  cookie: {
    title: "Cookie Policy",
    intro: "We use a small number of cookies and similar technologies to make AlumniPulse work.",
    sections: [
      ["Essential cookies", "Required to sign you in and keep your session secure. The platform cannot function without these."],
      ["Preferences", "We store lightweight preferences (such as your chosen language on an institution website) in your browser's local storage so your choices persist."],
      ["Analytics", "We may use privacy-conscious analytics to understand aggregate usage and improve the product. These do not identify you personally."],
      ["Managing cookies", "You can clear or block cookies in your browser settings, though some features may stop working if you do."],
    ],
  },
};

export default function Legal({ kind }) {
  const c = CONTENT[kind] || CONTENT.terms;
  useSeo(c.title, c.intro);
  return (
    <div className="mx-auto max-w-3xl px-5 py-14">
      <h1 className="font-heading text-4xl font-light tracking-tight">{c.title}</h1>
      <p className="mt-3 text-muted-foreground">{c.intro}</p>
      <p className="mt-1 text-xs text-muted-foreground">Last updated: June 2026</p>
      <div className="mt-8 space-y-8">
        {c.sections.map(([h, b], i) => (
          <section key={i}>
            <h2 className="font-heading text-xl font-medium">{h}</h2>
            <p className="mt-2 leading-relaxed text-foreground/90">{b}</p>
          </section>
        ))}
      </div>
      <p className="mt-12 text-sm text-muted-foreground">© 2026 AlumniPulse.net — Social Pulse Inc</p>
    </div>
  );
}
